'use strict';

module.exports = function sortKeys() {
  var _this = this;

  var ordered = {};
  Object.keys(this.items).sort().forEach(function (key) {
    ordered[key] = _this.items[key];
  });
  return new this.constructor(ordered);
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/sortKeys.js
// module id = 1720
// module chunks = 2